// extracted by mini-css-extract-plugin
module.exports = {"watchlist-container":"Watchlist_watchlist-container__1xJ8J","message":"Watchlist_message__2KW-9","pagination":"Watchlist_pagination__Y8hmK"};